/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type {
    GenericCheckboxCondition,
    DocumentUploadCondition,
    DefaultCondition,
    GenericDropdownCondition,
    NumericCondition,
    SelectCondition,
    CheckboxCondition,
} from './';

export type ShowConditionsValue = CheckboxCondition | DefaultCondition | DocumentUploadCondition | GenericCheckboxCondition | GenericDropdownCondition | NumericCondition | SelectCondition;

